import React, { Component } from "react";


import { Link } from 'react-router-dom';
import TextField from '@material-ui/core/TextField';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';

class GlossaryUploadForm extends Component {
	constructor(props) {
		super(props);
		this.state = {
			fileSelectd: 0,
			uploading: 0,
			description: this.props.glossary?this.props.glossary.description:"",
			glossaryFile: ''
		};
		this.handleDocument = this.handleDocument.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleChange = this.handleChange.bind(this);
	}
	
	componentWillReceiveProps(nextProps) {
		if (nextProps.glossary !== this.props.glossary) {
			this.setState({ description: nextProps.glossary.description });
		}
	}
  
	handleDocument(e) {
		this.setState({fileSelectd: 1});
		this.setState({glossaryFile: e.target.files[0]});
		if(this.state.description.length==0){
			this.setState({description: e.target.files[0].name});
		}
		//console.log("Extension: "+extension+" ["+this.state.esXLIFF+"]");
	}
	
	handleChange(e) {
		e.preventDefault();
		this.setState({[e.target.name]: e.target.value });
	}
	
	handleSubmit(e) {
		this.setState({uploading: 1});
		this.props.uploadGlossary(this.state.glossaryFile, this.state.description)
			.then(response => { return this.setState({uploading: 2});})
			.catch(err => {/*console.log(err);*/});
	}
	
	render() {
		let button2="";
		const disabled = !((this.state.fileSelectd>0) || this.props.glossary!=0) ;
		if (this.state.uploading>0) {
			return <div className="content_centered">UPLOADING....</div>;
		}

		button2=<Grid item>
					<Button disabled={disabled} style={{fontFamily: "'Lato', sans-serif", fontSize: "12px", backgroundColor: "#dfdfdf"}} onClick={this.handleSubmit} color="primary">
						Upload
					</Button>
				</Grid>
		
		return (
			<form>
			<Grid container item direction="column" alignItems="flex-start" justify="flex-start" spacing={2}>
				<Grid item>
					<h1 className="title">Upload Glossary</h1>
				</Grid>
				<Grid item container direction="row" alignItems="flex-start" justify="flex-start" spacing={2}>
					
				</Grid>
				<Grid item>
					<TextField
						id="description"
						name="description"
						label="Glossary name: "
						margin="normal"
						value={this.state.description}
						onChange={this.handleChange}
					/>
				</Grid>
				<Grid item container direction="row" alignItems="center" justify="flex-start" spacing={2}>
					<Grid item>
						<Paper>
							<Button label="Choose Glossary" component="span">
								<input type="file" name="docuemnt" style={{ overflow: 'hidden' }} onChange={this.handleDocument}/>
							</Button>
						</Paper>
					</Grid>
				</Grid>
				<Grid item container direction="row" alignItems="flex-start" justify="flex-start" spacing={2}>
					{button2}
				</Grid>
			</Grid>
			</form>
		);
	}
}

export default GlossaryUploadForm;